import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL
});

export const clearPersistedGridFilters = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.endsWith('_filters')) {
      localStorage.removeItem(key);
    }
  });
};

const isIgnoredUnauthorizedRoute = (url?: string) => {
  if (!url) return false;

  return (
    url.includes('/autenticar/login') ||
    url.includes('/autenticar/logout') ||
    url.includes('/autenticar/tokenRedefinicaoSenha') ||
    url.includes('/autenticar/redefinirSenhaComCodigo')
  );
};

const redirectToExpiredSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('permissions');
  clearPersistedGridFilters();
  delete api.defaults.headers.common.Authorization;

  const isAlreadyOnExpiredLogin =
    window.location.pathname === '/' &&
    window.location.search.includes('sessionExpired=true');

  if (!isAlreadyOnExpiredLogin) {
    window.location.replace('/?sessionExpired=true');
  }
};

// const { onRefreshToken } = useBreadcrumb();

api.interceptors.response.use(function (config) {
  return config;
}, function (error) {
  // Envia mensagem caso retorne 401
  if (error.response?.status === 401 && !isIgnoredUnauthorizedRoute(error.config?.url)) {
    redirectToExpiredSession();
  }

  // history.push('/');
  // window.location.reload();

  return Promise.reject(error);
});


export default api;
